<template>
    <v-client-table class="dataTables_wrapper" :data="payments" :columns="columns" :options="clientTableOptions">
        <d-button-group slot="buttons" slot-scope="props" size="small" class="d-flex justify-content-center">
            <button class="btn btn-secondary btn-sm">Switch to this plan</button>
        </d-button-group>
        <d-col slot="invoice" slot-scope="props" size="small">
            <a :href="restUrl + 'payments/' + props.row.id + '/invoice?token=' + token" target="_blank"><i class="fa">&#xf1c1;</i> Download PDF</a>
        </d-col>
    </v-client-table>
</template>

<script>
import { UserService, AuthService } from '@/main';
import notification from '@/mixins/notification';

export default {
    mixins: [notification],

    data() {
        return {
            restUrl: process.env.VUE_APP_REST_API,
            token: AuthService.getToken(),
            payments: [],
            columns: ['id', 'payment_date', 'product_name', 'amount', 'tax_amount', 'price', 'currency', 'status', 'invoice'],

            /**
                 * Vue Tables Configuration Options
                 * @see https://github.com/matfish2/vue-tables-2
                 */
            clientTableOptions: {
                perPage: 25,
                orderBy : { column: 'payment_date', ascending: false },
                childRowTogglerFirst: false,
                recordsPerPage: [25, 50, 100],
                skin: 'transaction-history table dataTable',
                texts: {
                    limit: 'Show',
                    count: ''
                },
                headings: {
                    id: 'Transaction ID',
                    payment_date: 'Date',
                    product_name: 'Plan',
                    amount: 'Amount',
                    tax_amount: 'Tax',
                    currency: 'Currency',
                    price: 'Total',
                    status: 'Status',
                    invoice: 'Invoice',
                },
                columnsDisplay: {
                    date: 'desktop',
                    paymentAmount: 'desktop',
                    taxAmount: 'desktop',
                    currency: 'desktop',
                    status: 'desktop',
                },
            },
        };
    },

    methods: {
        async getPayments() {
            try {
                this.payments = await UserService.getPayments()
            } catch(e) {
                console.log(e)
                this.showNotification('warn', 'We have a problem', 'Oops! cant get payments')
            }
        }
    },

    created () {
        this.getPayments()
    }
};
</script>
